import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { AUTO_GEN_REVIEWS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useAutoGenReviews(dispensaryId: string) {
  const banksApi = new BanksApi();
  const { userBankId } = useUser();

  const { data: autoGenReviews, isLoading: isLoadingAutoGenReviews } = useQuery({
    enabled: !!dispensaryId.length && !!userBankId.length,
    queryKey: [AUTO_GEN_REVIEWS_KEY, userBankId, dispensaryId],
    queryFn: () => banksApi.getAutoGenReviews(userBankId, dispensaryId)
  });

  return { autoGenReviews, isLoadingAutoGenReviews };
}
